import { render } from "./CrearContratoGeneral.vue?vue&type=template&id=763d0a94"
import script from "./CrearContratoGeneral.vue?vue&type=script&lang=js"
export * from "./CrearContratoGeneral.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__